/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Indicates the status of a ServiceTitan.CustomerPortal.Models.Job.
 */
export type JobStatus = 0 | 1 | 2 | 3 | 4 | 5;

export const JobStatus = {
    NUMBER_0: 0 as JobStatus,
    NUMBER_1: 1 as JobStatus,
    NUMBER_2: 2 as JobStatus,
    NUMBER_3: 3 as JobStatus,
    NUMBER_4: 4 as JobStatus,
    NUMBER_5: 5 as JobStatus
}